import { ILoadPageResult } from './layout-build-types.js';
import { LayoutError } from './layout-error.js';

export const LayoutErrorBoundaryWrapper = ({ pageComponent }: { pageComponent: ILoadPageResult }) => {
  if (pageComponent && !pageComponent.layoutLoadSuccess) {
    return (
      <div className="errorMain">
        <LayoutError res={pageComponent} />
      </div>
    );
  }
  return pageComponent.layoutComponent;
};
